
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcHorizontalLine as ObcHorizontalLineElement} from '@oicl/openbridge-webcomponents/dist/automation/horizontal-line/horizontal-line.js';
 
 
 

 
 export const ObcHorizontalLine = createComponent({
   react: React,
   tagName: 'obc-horizontal-line',
   elementClass: ObcHorizontalLineElement,
   events: {
     
   }
  });
 
 